
export const formatDateString = (date, separator = '/') => {

    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();

    return dia + separator + mes + separator + ano;
}